export interface CaseStudyItalianMetadataItem {
  title: string;
  summary: string;
  tags: string[];
}

export const caseStudyItalianMetadata: Record<string, CaseStudyItalianMetadataItem> = {
  "deeptrait-ngs-data-analysis": {
    "title": "Analisi NGS per la scoperta di farmaci",
    "summary": "Abbiamo co-fondato e sviluppato una piattaforma AI per l'analisi dei dati NGS che permette agli scienziati di laboratorio di individuare nuovi target terapeutici e biomarcatori diagnostici in meno di sei ore, senza codice, script o riga di comando.",
    "tags": [
      "Sviluppo dell'intelligenza artificiale",
      "Bioinformatica",
      "Farmaceutica e sanità"
    ]
  },
  "astrazeneca-medical-affairs-ai": {
    "title": "Prodotto AI per affari medici",
    "summary": "Abbiamo sviluppato uno strumento AI per l'analisi degli insight e una pipeline dedicata per un'azienda farmaceutica globale, automatizzando l'analisi dei record CRM e generando insight operativi per i medical affairs su larga scala.",
    "tags": [
      "Sviluppo dell'intelligenza artificiale",
      "IA generativa",
      "Farmaceutica e sanità"
    ]
  },
  "civitta-ai-accelerator-consulting": {
    "title": "Architettura AI per startup AI generative",
    "summary": "Abbiamo fornito consulenza tecnologica AI a quattro startup del Challenger AI Accelerator, definendo strategie di prodotto complete e piani di implementazione concreti, inclusi i blueprint di architettura di sistema.",
    "tags": [
      "Strategia dell'intelligenza artificiale",
      "Consulenza",
      "IA generativa"
    ]
  },
  "xfusion-rag-chatbot": {
    "title": "Chatbot RAG per una piattaforma dati enterprise",
    "summary": "Abbiamo progettato un sistema RAG avanzato per la piattaforma xAQUA® di xFusion, che consente interrogazioni in linguaggio naturale su repository di documenti aziendali.",
    "tags": [
      "Sviluppo dell'intelligenza artificiale",
      "RAG",
      "Imprese e governo"
    ]
  },
  "periodix-lead-generation-ai": {
    "title": "Assistente alle vendite AI per la lead generation",
    "summary": "Abbiamo sviluppato un assistente alle vendite basato su AI generativa, costruito su un modello Llama-2 ottimizzato e distribuito come componente cloud pronto per la lead generation.",
    "tags": [
      "Sviluppo dell'intelligenza artificiale",
      "IA generativa",
      "Messa a punto LLM",
      "Vendite e marketing"
    ]
  },
  "dynamiq-genai-platform-strategy": {
    "title": "Strategia AI generativa per la piattaforma",
    "summary": "Abbiamo definito una strategia completa di AI generativa che include analisi di mercato, fine-tuning degli LLM e integrazione RAG per una piattaforma leader del settore.",
    "tags": [
      "Strategia dell'intelligenza artificiale",
      "IA generativa",
      "Messa a punto LLM",
      "Imprese e governo"
    ]
  },
  "axbio-questionnaire-analysis": {
    "title": "Analisi AI di questionari sanitari",
    "summary": "Abbiamo creato una piattaforma cloud end-to-end che raccoglie le risposte ai questionari sanitari, applica scoring ponderato e usa Azure OpenAI per generare report personalizzati inviati automaticamente via email.",
    "tags": [
      "Sviluppo dell'intelligenza artificiale",
      "IA generativa",
      "Farmaceutica e sanità"
    ]
  },
  "pumb-retail-banking-ai-strategy": {
    "title": "Strategia AI per la banca al dettaglio",
    "summary": "Abbiamo progettato una strategia AI completa per una grande banca retail, includendo analisi della concorrenza, raccomandazioni sui modelli e una roadmap di trasformazione tecnologica.",
    "tags": [
      "Strategia dell'intelligenza artificiale",
      "Banking e finanza"
    ]
  },
  "bank-rag-chatbot": {
    "title": "Chatbot RAG per una grande banca canadese",
    "summary": "Abbiamo realizzato un sistema RAG pronto per la produzione che consente risposte intelligenti su oltre 3.200 documenti interni usando Azure OpenAI e LangChain.",
    "tags": [
      "Sviluppo dell'intelligenza artificiale",
      "RAG",
      "IA generativa",
      "Banking e finanza"
    ]
  }
};
